/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pie Chart Maker`)
};

const es_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos Circulares`)
};

const de_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreisdiagramm-Ersteller`)
};

const nl_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cirkeldiagrammaker`)
};

const fr_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme circulaire`)
};

const it_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a torta`)
};

const pt_br2_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Pizza`)
};

const pt_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos Circulares`)
};

const ja_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`円グラフ作成ツール`)
};

const zh_pie_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`饼图制作工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_tool_name", locale)
	if (locale === "en") return en_pie_tool_name(inputs)
	if (locale === "es") return es_pie_tool_name(inputs)
	if (locale === "de") return de_pie_tool_name(inputs)
	if (locale === "nl") return nl_pie_tool_name(inputs)
	if (locale === "fr") return fr_pie_tool_name(inputs)
	if (locale === "it") return it_pie_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_pie_tool_name(inputs)
	if (locale === "pt") return pt_pie_tool_name(inputs)
	if (locale === "ja") return ja_pie_tool_name(inputs)
	return zh_pie_tool_name(inputs)
};